export class CommonMethod {
    static getId(x: number, y: number) {
        return `map_${x}_${y}`
    }
}